














































import {Component, Vue, Watch} from "vue-property-decorator";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import FilmBlock from "@/modules/Rhizome/components/FilmBlock.vue";
import {CoordinatesJsService} from "@/modules/Rhizome/services/coordinates-js.service";
import {Coordinates} from "@/modules/Rhizome/interfaces/coordinates.interface";
import {AnimationJsService} from "@/modules/Rhizome/services/animation-js.service";
import {bus} from "@/plugins/bus";
import {localStorageService} from "@/services/local-storage.service";
import {rhizomeResource} from "@/modules/Rhizome/resources/rhizome.resource";
import Loader from "@/components/Loader.vue";
import {RhizomeViewType} from "@/modules/Rhizome/interfaces/state.interface";
import IFilm = Film.IFilm;
import ZoomControls from "@/modules/Rhizome/components/ZoomControls.vue";
import {LocalStorageServiceConfig} from "@/interfaces/local-storage.interface";

@Component({
  components: {
    FilmBlock,
    Loader,
    ZoomControls,
  }
})
export default class RhizomeCloud extends Vue {
  arrayFilms: Film.IFilm[] = [];
  activeLines = [];
  hoverLines = [];
  activeId = null;
  animationJsService: any;
  statuses = Film.FilmState;
  dragging = false;
  cloud: any = null;
  startX = 0;
  startY = 0;
  startMouseX = 0;
  startMouseY = 0;
  timeOut = 0;
  interval: any = null;
  timer = {
    count: 3,
  };
  favoriteInterval = null;
  yearLabels = [];
  rhizomeViews = RhizomeViewType;

  get scaleCloud(): number {
    return this.$store.state.rhizome.scaleCloud;
  }

  get showFavorites(): boolean {
    return this.$store.state.rhizome.showFavorites;
  }

  get activeView(): RhizomeViewType {
    return this.$store.state.rhizome.viewType;
  }

  async created() {
    this.prepareListFilms();
    this.$store.commit('rhizome/setPropertyInState', { name: 'scaleCloud', value: 1 });
    // this.redrawLinesForFavorite();
  }

  async mounted() {
    this.cloud = this.$refs['cloud-draggable'];
    this.cloud.style.transform = `
    translate(${-5000 + document.querySelector('.rhizome-view').clientWidth / 2}px,
              ${-5000 + document.querySelector('.rhizome-view').clientHeight / 2}px)
    scale(${this.scaleCloud})`;

    this.startLoader();

    window.addEventListener('mouseup', this.stopDrag);

    bus.$on('redrawLines', (film) => {
      this.removeLines(true);
      this.addLines(film, true);
    });

    bus.$on('filterListKeyword', async ({keywordID, keywordValue}) => {
      if (keywordID && keywordValue) {
        localStorageService.pushHistory(
            {
              type: LocalStorageServiceConfig.HistoryItemTypes.KEYWORD,
              keyword: {
                entity_id: keywordID,
                keyword: keywordValue,
              },
            }
        );
      }

      this.startLoader();
      this.removeActive();
      await this.getFilmsByKeyword(keywordID);
    });

    if (this.$store.state.rhizome.filterByKeyword) {
      await this.getFilmsByKeyword(this.$store.state.rhizome.filterByKeyword.id);
    }
    else {
      this.drawRhizome();

      if (this.$store.state.rhizome.preActiveFilm) {
        let film = this.arrayFilms.find(film => film.id === this.$store.state.rhizome.preActiveFilm);
        if (film) {
          this.addActive(film);
          this.positioningFocusOnActive(film);
        }
      }
    }
  }

  async getFilmsByKeyword(keywordId: number) {
    try {
      let response = await rhizomeResource.getList(keywordId);
      this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: false });
      this.arrayFilms = this.$store.state.rhizome.filmsList;
      this.$store.commit('rhizome/setPropertyInState', { name: 'filmsList', value: response });
      let ordersFilms = this.shuffle(response);
      this.$store.commit('rhizome/setPropertyInState', { name: 'ordersFilmList', value: ordersFilms });
      if(response.length === 0) {
        this.prepareListFilms(this.arrayFilms)
      } else {
        this.prepareListFilms();
      }
      setTimeout(this.drawRhizome, 0);
    }
    catch(e) {
      console.log(e);
      this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: true });
    }

  }

  positioningFocusOnActive(film) {
    let item = this.$refs[`film-${film.id}`][0];
    let translateX = -5000;
    let translateY = -5000;
    if (item) {
      let translate = item.style.transform.split(' ');
      translateX += +translate[0].replace('translate(', '').replace('px,', '');
      translateY += +translate[1].replace('px)', '');
    }
    let x = -5000 + document.querySelector('.rhizome-view').clientWidth / 2 - translateX;
    let y = -5000 + document.querySelector('.rhizome-view').clientHeight / 2 - translateY;

    this.cloud.style.transform = `translate(${x}px, ${y}px) scale(${this.scaleCloud})`;
  }

  startLoader() {
    this.timer.count = 3;
    let interval = setInterval(() => {
      if (this.timer.count === 0) {
        clearInterval(interval);
      }
      else {
        this.timer.count--;
      }
    }, 1000);
  }

  drawRhizome() {
    switch (this.activeView) {
      case RhizomeViewType.CIRCLE:
        this.drawCircle();
        break;

      case RhizomeViewType.CLOUD:
      default:
        this.drawCloud();
        break;
    }
  }

  drawCloud() {
    let arrayCloudFilms: Film.IFilmCloud[] = [];

    let coordsConfig = {
      viewType: Coordinates.ViewType.cloud,
      canvas: document.querySelector('.rhizome-cloud'),
      centerCoords: {
        left: document.querySelector('.rhizome-cloud').clientWidth / 2,
        top: document.querySelector('.rhizome-cloud').clientHeight / 2,
      },
    };
    this.arrayFilms.forEach((film, index) => {
      let coords = new CoordinatesJsService({ index, ...coordsConfig });

      if (!this.$refs[`film-${film.id}`]) return;
      let currentDomElement = this.$refs[`film-${film.id}`][0];
      if (currentDomElement) {
        currentDomElement.style.transform = `translate(${coords.x}px, ${coords.y}px)`;

        let cloudFilm: Film.IFilmCloud = this.prepareFilmsForAnimations(coords.x, coords.y, film, currentDomElement);
        arrayCloudFilms.push((cloudFilm as Film.IFilmCloud));
      }
    });

    this.animationJsService = new AnimationJsService(arrayCloudFilms);
  }

  drawCircle() {
    let arrayCloudFilms: Film.IFilmCloud[] = [];
    let x0 = document.querySelector('.rhizome-cloud').clientWidth / 2;
    let y0 = document.querySelector('.rhizome-cloud').clientHeight / 2;

    let sectors = this.sortedFilmsForCircle(this.arrayFilms);
    sectors.forEach(sector => {
      let radius = 400;
      let angleStep = this.arrayFilms.length > 24 ? 15 : 360 / this.arrayFilms.length;
      let angleInterval = sector.percent < angleStep ? angleStep : sector.percent;
      let angleStart = -90 + sector.percentStart;

      let count = 0;
      let countCircles = 1;
      sector.films.forEach((film, index) => {
        let numberFilmsInCircle = angleInterval < angleStep ? 1 : Math.floor(angleInterval / angleStep);
        if (count >= numberFilmsInCircle) {
          countCircles++;
          if (countCircles === 2) angleStep = 7;
          if (countCircles === 5) angleStep = 3.9;
          if (countCircles > 5) angleStep -= 0.2;
          radius += 200;
          count = 1;
        }
        else {
          count++;
        }
        let angle = angleStart + angleStep * (count - 1);

        let x = x0 + radius * Math.cos(angle * 0.0175);
        let y = y0 + radius * Math.sin(angle * 0.0175);

        if (!this.$refs[`film-${film.id}`]) return;
        this.$refs[`film-${film.id}`][0].style.transform = `translate(${x}px, ${y}px)`;

        let cloudFilm: Film.IFilmCloud = this.prepareFilmsForAnimations(x, y, film, this.$refs[`film-${film.id}`][0]);
        arrayCloudFilms.push((cloudFilm as Film.IFilmCloud));
      });
    });

    this.animationJsService = new AnimationJsService(arrayCloudFilms);
    this.printYears(sectors, arrayCloudFilms.length);
  }

  sortedFilmsForCircle(arrayFilms: any[]) {
    const countSectors = 24;
    let sortedFilms: any[] = [];
    arrayFilms.forEach((film) => sortedFilms.push(film));
    sortedFilms.sort((filmA, filmB) => filmA.year - filmB.year);

    const balance = sortedFilms.length % countSectors;
    const numberInSector = Math.floor(sortedFilms.length / countSectors);

    let sectors: any[] = [];
    let sectorIndex = 0;
    sortedFilms.forEach((film) => {
      let currentNumberInSector = sectorIndex > balance - 1 ? 0 : 1;

      if (sectors[sectorIndex]?.films.length === numberInSector + currentNumberInSector) {
        sectorIndex++;
      }

      if (!sectors[sectorIndex]) {
        sectors[sectorIndex] = {};
        sectors[sectorIndex].year = film.year;
        sectors[sectorIndex].films = [film];
      }
      else {
        sectors[sectorIndex].films.push(film);
      }
    });

    let total = sortedFilms.length;
    let sum = 0;
    const minAngle = total > 24 ? 15 : 360 / total;
    let leftSpace = 360;
    sectors.forEach(sector => {
      sector.percent = sector.films.length / total * leftSpace;
      sector.percentStart = sum;

      if (sector.percent < minAngle) sector.percent = minAngle;
      else sector.percent = Math.floor(sector.percent / minAngle) * minAngle;

      total -= sector.films.length;
      leftSpace -= sector.percent;
      sum += sector.percent;
    });

    return sectors;
  }

  prepareFilmsForAnimations(x: number, y: number, film: IFilm, element: any): Film.IFilmCloud {
    let cloudFilm = {
      ...film,
      originalPosition: { x, y },
      originalCenter: {
        x: x + (element.querySelector('.preview').scrollWidth / 2),
        y: y + (element.querySelector('.preview').scrollHeight / 2),
      },
      scaledSize: {
        width: element.querySelector('.preview').scrollWidth * 3.2,
        height: element.querySelector('.preview').scrollHeight * 3.2,
      },
      refDomElement: element,
    };
    (cloudFilm as Film.IFilmCloud).activeSidesCoords = {
      leftX: x,
      rightX: x + element.querySelector('.preview').scrollWidth,
      topY: y,
      bottomY: y + element.querySelector('.preview').scrollHeight,
    };

    return cloudFilm as Film.IFilmCloud;
  }

  printYears(sectors: any[], countFilms: number) {
    this.yearLabels = [];
    const x0 = document.querySelector('.rhizome-cloud').clientWidth / 2;
    const y0 = document.querySelector('.rhizome-cloud').clientHeight / 2;

    if (countFilms > 24) {
      sectors.forEach((sector, index) => {
        const yearToLabel = Math.floor(sector.year / 10) * 10;
        if (this.yearLabels.includes(yearToLabel)) {
          this.yearLabels.push('');
        } else {
          this.yearLabels.push(yearToLabel);
        }
      });
    }
    else {
      sectors.forEach(sector => this.yearLabels.push(sector.year));
    }

    setTimeout(() => {
      const angleStep = countFilms > 24 ? 15 : 360 / countFilms;
      const radius = 200;
      let angle = 0;
      this.yearLabels.forEach((year, index) => {
        let x = x0 + radius * Math.cos( (-90 + angle) * 0.0175);
        let y = y0 + radius * Math.sin( (-90 + angle) * 0.0175);
        this.$refs[`year-${year}-${index}`][0].style.transform = `translate(${x}px, ${y}px)`;
        angle += angleStep;
      });
    }, 0);
  }

  getStatus(film: Film.IFilm) {
    let status: Film.FilmState = Film.FilmState.DEFAULT;
    if (this.activeId === null) status = Film.FilmState.DEFAULT;
    if (this.activeId === film.id) status = Film.FilmState.ACTIVE;
    if (this.activeId !== film.id && this.activeId !== null) status = Film.FilmState.INACTIVATED;

    let activeFilm = this.arrayFilms.find(film => film.id === this.activeId);
    if (activeFilm?.connectionWith?.find(connectionLine => connectionLine.id === film.id)) {
      status = Film.FilmState.CONNECTED_WITH;
    }

    return status;
  }

  addLines(film: Film.IFilm, active: boolean = false) {
    let heroVideo = this.$refs[`film-${film.id}`][0];
    if (!heroVideo) return;

    let translate = heroVideo.style.transform.split(' ');
    let translateX = +translate[0].replace('translate(', '').replace('px,', '');
    let translateY = +translate[1].replace('px)', '');
    let posVideo = {
      x: translateX + (heroVideo.querySelector('.preview').scrollWidth / 2),
      y: translateY + (heroVideo.querySelector('.preview').scrollHeight * 2.5),
    };

    if (film.connectionWith?.length) {
      film.connectionWith.forEach(connectionLine => {
        let connectedFilm = this.arrayFilms.find((film: Film.IFilm) => film.id === connectionLine.id);
        if (connectedFilm) {
          let item = this.$refs[`film-${connectedFilm.id}`][0];
          if (item) {
            let translate = item.style.transform.split(' ');
            let translateX = +translate[0].replace('translate(', '').replace('px,', '');
            let translateY = +translate[1].replace('px)', '');
            let itemPos = {
              x: translateX + (item.querySelector('.preview').scrollWidth / 2),
              y: translateY + (item.querySelector('.preview').scrollHeight * 2.5),
            };

            let pathStr = "M" +
              (posVideo.x) + "," + (posVideo.y) + " " +
              "C" +
              (posVideo.x) + "," + (posVideo.y + ((itemPos.y - posVideo.y) / 2)) + " " +
              (itemPos.x - ((itemPos.x - posVideo.x) / 2)) + "," + (itemPos.y) + " " +
              (itemPos.x) + "," + (itemPos.y);

            let line = {
              path: pathStr,
              weight: connectionLine.weight
            };
            if (active) this.activeLines.push(line);
            else this.hoverLines.push(line);
          }
        }
      });
    }
  }

  removeLines(active: boolean = false) {
    if (active) this.activeLines = [];
    else this.hoverLines = [];
  }

  addHover(film: Film.IFilm, actionType?: string) {
    if ((this.$device.ios || this.$device.android) && actionType === 'mouse') return;
    // Do nothing with lines in favorite mode.
    // if (this.showFavorites) return;

    if (this.activeId !== film.id) {
      if (this.hoverLines.length !== 0) this.removeHover();
      this.addLines(film);
    }
  }

  removeHover(actionType?: string) {
    if ((this.$device.ios || this.$device.android) && actionType === 'mouse') return;
    this.removeLines();
  }

  addActive(film: Film.IFilm, actionType?: string) {
    if ((this.$device.ios
      || this.$device.ipad
      || this.$device.android
      || navigator.maxTouchPoints > 0
      || navigator.msMaxTouchPoints > 0)
        && actionType === 'mouse')
      return;

    if (this.activeId !== film.id) {
      this.activeId = film.id;
      this.removeLines();
      this.removeLines(true);
      this.addLines(film, true);
      this.animationJsService.moveFromActive(film);
    }
    else {
      this.$store.dispatch('routerStore/openFilmPage', film.id);
    }
  }

  startDrag(event) {
    this.dragging = true;
    let translate = this.cloud.style.transform.split(' ');
    this.startX = translate[0].replace('translate(', '').replace('px,', '');
    this.startY = translate[1].replace('px)', '');

    switch (event.type) {
      case 'mousedown':
        this.startMouseX = event.clientX;
        this.startMouseY = event.clientY;
        break;
      case 'touchstart':
        this.startMouseX = event.changedTouches[0].clientX;
        this.startMouseY = event.changedTouches[0].clientY;
        break;
    }

    this.clearDragInterval();
    this.interval = setInterval(() => this.timeOut += 125, 125);
  }

  stopDrag() {
    if (this.dragging) {
      this.dragging = false;
      if (this.timeOut <= 250) {
        this.removeActive();
        this.clearDragInterval();
      }
    }
  }

  clearDragInterval() {
    clearInterval(this.interval);
    this.timeOut = 0;
    this.interval = null;
  }

  doDrag(event) {
    if (this.dragging && this.startMouseX !== event.clientX) {

      let diffX, diffY;
      switch (event.type) {
        case 'mousemove':
          diffX = this.startMouseX - event.clientX;
          diffY = this.startMouseY - event.clientY;
          break;
        case 'touchmove':
          diffX = this.startMouseX - event.changedTouches[0].clientX;
          diffY = this.startMouseY - event.changedTouches[0].clientY;
          break;
      }
      this.cloud.style.transform = `translate(${this.startX - diffX}px, ${this.startY - diffY}px) scale(${this.scaleCloud})`;

    }
  }

  removeActive() {
    this.animationJsService.moveToStartPosition();
    this.activeId = null;
    this.removeLines(true);
  }

  prepareListFilms(films?:Film.IFilm[]) {
    if(!films) {
      if (this.showFavorites) {
        let favoriteList = localStorageService.getFavoriteList();
        if (favoriteList?.length) {
          this.arrayFilms = this.$store.state.rhizome.filmsList.filter(film => favoriteList.includes(film.id));
        }
      }
      else {
        if (this.$store.state.rhizome.ordersFilmList.length !== 0) {
          this.arrayFilms = this.$store.state.rhizome.ordersFilmList;
        }
        else {
          this.arrayFilms = this.shuffle(this.$store.state.rhizome.filmsList);
          this.$store.commit('rhizome/setPropertyInState', { name: 'ordersFilmList', value: this.arrayFilms });
        }
      }
    }
  }

  redrawLinesForFavorite() {
    if (this.showFavorites) {
      this.favoriteInterval = setInterval(() => {
        this.removeLines(true);
        this.arrayFilms.forEach(film => {
          this.addLines(film, true);
        });
      }, 1);
    }
    else {
      clearInterval(this.favoriteInterval);
      this.favoriteInterval = null;
      this.removeLines(true);
    }
  }

  shuffle(arr){
    let j, temp;
    for(let i = arr.length - 1; i > 0; i--){
      j = Math.floor(Math.random()*(i + 1));
      temp = arr[j];
      arr[j] = arr[i];
      arr[i] = temp;
    }
    return arr;
  }

  @Watch('showFavorites')
  onShowFavoritesChange() {
    this.prepareListFilms();
    setTimeout(this.drawRhizome, 0);
    // this.redrawLinesForFavorite();
  }

  @Watch('activeView')
  onActiveViewChange() {
    const activeFilmId = this.activeId;
    this.removeActive();
    this.prepareListFilms();
    setTimeout(() => {
      this.drawRhizome();
      const film = this.arrayFilms.find(film => film.id === activeFilmId);
      if (film) {
        setTimeout(() => this.addActive(film), 2000);
      }
    }, 0);
  }

  destroyed() {
    bus.$off('redrawLines');
    bus.$off('filterListKeyword');

    // clearInterval(this.favoriteInterval);
    // this.favoriteInterval = null;
    this.removeLines(true);
  }
}
